// extracted by mini-css-extract-plugin
export default {"header":"styles_header__H7UWR","logo":"styles_logo__3+yow"};